{
  "nl": {
    "message": {
      "actions": {
        "delete_message": "Verwijder bericht",
        "move_selected": "Geselecteerde berichten verplaatsen",
        "send": "Verstuur"
      },
      "labels": {
        "already_replied": "reeds beantwoord",
        "cannot_delete_message": "Berichten gelezen door klanten kunnen niet meer worden verwijderd",
        "changes_not_saved": "Je hebt niet-opgeslagen wijzigingen. Ben je zeker dat je wil verdergaan?\np.s.: Je kan ook een nieuwe tab openen om tegelijkertijd te navigeren naar andere paginas",
        "delete_message": "Dit bericht wordt definitief verwijderd",
        "delete_message_abort": "Dit bericht kan niet worden verwijderd",
        "move_customer_notification": "De klant krijgt een melding wanneer het bericht wordt verplaatst naar een ander gesprek",
        "move_to": "Bericht verplaatsen naar...",
        "moved_here": "vanuit gesprek",
        "moved_message": "dit bericht verplaatst",
        "moving_message": "bericht aan het verplaatsen",
        "notSeenYet": "Nog niet gezien",
        "seen_by": "Gezien door {participants}",
        "to": "naar",
        "you": "jij hebt"
      },
      "validation": {
        "message_required": "Bericht vereist"
      }
    }
  }
}
